import { UseInfiniteQueryResult } from "@tanstack/react-query";
import { useEffect, useEffectEvent } from "react";
import { useIntersectionObserver } from "usehooks-ts";
import { InfiniteLoadingButton } from "./InfiniteLoadingButton";

export const IntersectingInfiniteLoadingButton = ({
  query,
}: {
  query: UseInfiniteQueryResult;
}) => {
  const [ref, isIntersecting] = useIntersectionObserver({});
  const fetchNextPage = useEffectEvent(() => query.fetchNextPage());

  useEffect(() => {
    if (
      isIntersecting &&
      query.data &&
      !query.isLoading &&
      !query.isFetchingNextPage
    ) {
      fetchNextPage();
    }
  }, [query.data, query.isLoading, query.isFetchingNextPage, isIntersecting]);

  return <InfiniteLoadingButton ref={ref} query={query} />;
};
